/**
 * What a list or section shows when it has nothing to show: what will appear here and how to make
 * it appear. `inline` is one line that sits flush with the section title above it. `page` is a
 * title, a sentence and at most one action, for a screen with nothing on it yet.
 */
import * as stylex from "@stylexjs/stylex";
import type { ReactNode } from "react";
import "@lattice/tokens/space.stylex";
import { space } from "@lattice/tokens/space.stylex";
import { Heading, Text } from "./Text.tsx";
export interface EmptyStateProps {
  readonly title: string;
  readonly body?: string;
  /** One action, such as a link or button. The page variant shows it below the text. */
  readonly action?: ReactNode;
  readonly variant?: "inline" | "page";
  /** The title's place in the outline, for the page variant. */
  readonly level?: 2 | 3;
  readonly testId?: string;
}
export function EmptyState({
  title,
  body,
  action,
  variant = "inline",
  level = 2,
  testId
}: EmptyStateProps) {
  if (variant === "inline") return <div data-testid={testId} className="x78zum5 x1a02dak x6s0dn4 x626il7">
        <Text tone="secondary">
          {title}
          {body === undefined ? "" : ` ${body}`}
        </Text>
        {action}
      </div>;
  return <div data-testid={testId} className="x78zum5 xdt5ytf x1cy8zhl x626il7 x12qliqu x13sch6v">
      <Heading level={level} size="sectionTitle">
        {title}
      </Heading>
      {body === undefined ? null : <Text tone="secondary">{body}</Text>}
      {action}
    </div>;
}